import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import fetchCountries from '@afosto/utils/fetchCountries';
import findObjectInArray from '@afosto/utils/array/findObjectInArray';

const CountryFormatter = ({ countryIso }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [country, setCountry] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchCountry = async iso => {
      setIsLoading(true);

      try {
        const countries = await fetchCountries();
        if (isMounted) {
          setCountry(findObjectInArray(countries, 'value', iso));
        }
      } catch (err) {
        if (isMounted) {
          setCountry(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (countryIso && countryIso !== '') {
      fetchCountry(countryIso);
    }

    return () => {
      isMounted = false;
    };
  }, [countryIso]);

  if (isLoading) {
    return <SkeletonBody lines={1} />;
  }

  return <Typography variant="body2">{country?.label ?? '-'}</Typography>;
};

CountryFormatter.propTypes = {
  countryIso: PropTypes.string,
};

CountryFormatter.defaultProps = {
  countryIso: undefined,
};

export default CountryFormatter;
